import { atomWithStorage } from "jotai/utils";

// eslint-disable-next-line import/prefer-default-export
export const selectedTenant = atomWithStorage("selectedTenant", null);
